<template>
  <div class="home flow-text">
    <Slider />
    <Options />
    <AboutUs />
  </div>
</template>

<script>
// components
import Slider from '@/components/home/SliderSection.vue';
import Options from '@/components/home/OptionsSection.vue';
import AboutUs from '@/components/home/AboutUsSection.vue';

export default {
  components: {
    Slider,
    Options,
    AboutUs,
  },

  beforeCreate: function () {
    // title, keywords, description
    this.$emit(
      'setPageInfo',
      'Inicio',
      'Consultor IT, Consultor Tecnológico, Arquitecto de Sistemas, Innovación Empresarial, Desarrollador Full-Stack, Soluciones Digitales para Empresas, Desarrollo Web, Bases de Datos, Cloud, \
      Big Data, Proyectos Tecnológicos, Optimización Web, Crecimiento Empresarial, Transformación Digital, Estrategias Digitales, Innovación Tecnológica, Freelance TI, Líder de Proyectos',
      'Ing. Obed Javier: Consultor en innovación IT, arquitecto de sistemas y desarrollador full-stack especializado en impulsar el crecimiento de empresas a través de soluciones digitales \
      eficientes que generan resultados reales.',
    );
    this.$emit('showMenu', true);
  },
};
</script>

<style lang="scss">
//@import '@/assets/styles/custom.scss';
@import '@/assets/styles/home.scss';
</style>
